export class KeyCode {
    public static readonly ENTER_KEY = 13
    public static readonly ESCAPE_KEY = 27
}